// import getConfig from 'next/config';

import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { getCookie, removeCookie } from '../../hooks/useCookie';
import { clearLocalStorage, getLocalStorage } from '../../hooks/useLocalStorage';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const EirAbondonJourney = ({
  openAbondonModal,

  setClearJourney,
  journeyType,
  hasChangedSubs,
  setJourneyCrossOver,
}) => {
  const router = useRouter();
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'mw-eir-action-modals-change-service',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  const handleOk = () => {
    const checkIfCookieExists = getCookie('selected_subscription') !== 'undefined';
    if (checkIfCookieExists) {
      const subs = JSON.parse(getCookie('selected_subscription'));
      if (subs?.serviceGroup === 'DUALPLAY') {
        if (hasChangedSubs === true) {
          openAbondonModal.disable();
        } else {
          router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband`);
        }
      } else if (subs?.serviceGroup === 'MOBILE') {
        if (getLocalStorage('STANDALONE_HANDSET')) {
          if (typeof window !== 'undefined') {
            window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/handsets`;
          }
        } else if (typeof window !== 'undefined') {
          window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`;
        }
      } else if (typeof window !== 'undefined') {
        window.location.href = `${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`;
      }
    }
  };
  const clearCurrentJourney = () => {
    clearLocalStorage();
    removeCookie('cart_Type');
    removeCookie('reference');
    removeCookie('selected_subscription');
    removeCookie('subscription_id');
    setJourneyCrossOver(true);

    if (journeyType === 'CHANGE_OFFER') setClearJourney(true);
    openAbondonModal.disable();
  };

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={openAbondonModal.value}
      handleClose={openAbondonModal.disable}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      title={cmsCollectionData?.attributes?.title}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `}
      cta={[
        {
          // text: `Yes `,
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Yes',
          type: 'contained',
          action: () => clearCurrentJourney(),
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
        },
        {
          // text: 'No ',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'No',
          type: 'solid',
          action: () => handleOk(openAbondonModal),
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default EirAbondonJourney;
